<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>物料管理</el-breadcrumb-item>
             <el-breadcrumb-item v-if="search.userType=='4'" :to="{ path: '/Warehousing' }">出库管理</el-breadcrumb-item>
             <el-breadcrumb-item v-if="search.userType=='3'" :to="{ path: '/outCon' }">出库管理</el-breadcrumb-item>
            <el-breadcrumb-item>库存表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
     
      <!-- 右边 -->
      <el-main
        class="build-CURD"
        style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 100%;"
      >
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <!-- <el-row :gutter="20" type="flex" justify="space-between"> -->
          <!-- <el-col :span="6"> -->
           <div
            style=" margin: 10px 20px;display:flex;justify-content: space-between;align-items: center;height:60px"
          >
            <div class="grid-search">
              <el-input v-model="search.name" placeholder="请输入材料名称"  clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
             <!-- <div class="grid-search" v-if="search.userType=='3'">
              <el-input v-model="search.projectRemarks" placeholder="请输入项目用途"  clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div> -->
            <div style="display:flex;align-items: center;width:50%;justify-content: space-between">
              <!-- <el-button type="primary" plain>拖拽项管理</el-button> -->
              <!-- <el-button type="primary" plain>导出</el-button> -->
              <!-- <el-button type="primary" plain>打印</el-button> -->
              <el-date-picker
                v-model="search.date"
                @change="doFilter"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择月"
              ></el-date-picker>
              <!-- <div style="display:flex;margin:0px 0px 0px 10px;"> -->
                <el-button
                 v-if="checked"
                  type="success"
                  @click="add"
                  style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
                >提交</el-button>
                  <!-- <el-button
                    type="success"
                    @click="exportma(1)"
                    style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
                  >导出模板</el-button>
                 <el-tooltip class="item" effect="dark" content="导出表" placement="top-end">
                    <img @click="exportma(2)"  class="icon_hover" src="../../../assets/image/export.png" alt="" srcset="">
                </el-tooltip>
                 <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHead"
                    :data="uploadData"
                    :show-file-list="false"
                    :on-success="handleAppSuccess"
                  >
                    
                  <el-tooltip class="item" effect="dark" content="导入表" placement="top-end">
                    <img  class="icon_hover" src="../../../assets/image/import.png" alt="" srcset="">
                </el-tooltip>
              </el-upload> -->
              <!-- </div> -->
            </div>
          </div>
          <!-- <div
            style="margin: 0px 20px 20px;display:flex;justify-content: space-between;justify-content: space-between;height:40px"
          >
            <el-date-picker
              v-model="search.month"
              @change="doFilter"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月"
            ></el-date-picker>
            <div style="display:flex;margin:0px 0px 0px 0px;">
              <el-button
                type="success"
                @click="exportAgree"
                style="margin-left:50px;background-color: #67C23A;border-color: #67C23A;"
              >导出表</el-button>
              <el-upload
                class="upload-demo"
                :action="uploadPersonUrl"
                :headers="uploadHead"
                :data="uploadPersonData"
                :show-file-list="false"
                style="margin-left:50px;"
                :on-success="personSuccess"
              >
                <el-button type="primary" icon="el-icon-upload">导入表</el-button>
              </el-upload>
            </div>
          </div> -->
          <div class="build-table">
            <el-table :data="listData" height="100%" border style="width: 100%;" stripe :header-cell-style="{background:'#F5F7F9',color:'#909399'}" @selection-change="handleSelectionChange">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index+1}}</a>
                </template>
              </el-table-column>
               <el-table-column label="产品编码">
                <template slot-scope="scope">
                  <a>{{scope.row.materialCoding }}</a>
                </template>
              </el-table-column>
              <el-table-column label="供应商">
                <template slot-scope="scope">
                  <a>{{ scope.row.supplier}}</a>
                </template>
              </el-table-column>
              <el-table-column label="材料名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.materialName }}</span>
                </template>
              </el-table-column>
             <el-table-column label="规格型号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.specifications }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量单位" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.measuringUnit }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="单价" prop="unitPrice">
                <template slot-scope="scope">
                  <span>{{ scope.row.unitPrice }}</span>
                </template>
              </el-table-column>         -->
               
              <el-table-column label="出库数量">
                <template slot-scope="scope">
                  <span v-if="!scope.row.flag">{{ scope.row.num }}</span>
                  <span v-else>
                  <el-input size="mini" placeholder="输入出库数量"  v-model="listData[scope.$index].num" @input="getNum(scope.row.num,scope.row.number,scope.row.registrar,scope.$index)" style="width:60%"></el-input>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="库存数量" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.number }}</span>
                </template>
              </el-table-column>
              <!--             
              <el-table-column label="登记人" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.registrar }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="领料人" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="!scope.row.flag">{{ scope.row.registrar }}</span>
                  <span v-else>
                  <el-input size="mini" placeholder="输入领料人" v-model="listData[scope.$index].registrar" @input="getNum(scope.row.num,scope.row.number,scope.row.registrar,scope.row.remarks,scope.row.projectRemarks,scope.$index)" ></el-input>
                  </span>
                </template>
              </el-table-column>
               <el-table-column label="用途" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="!scope.row.flag">{{ scope.row.remarks }}</span>
                  <span v-else>
                  <el-input size="mini" placeholder="输入用途" v-model="listData[scope.$index].remarks" @input="getNum(scope.row.num,scope.row.number,scope.row.registrar,scope.row.remarks,scope.row.projectRemarks,scope.$index)" ></el-input>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="项目用途" :show-overflow-tooltip="true" v-if="search.userType==3">
                <template slot-scope="scope">
                  <span v-if="!scope.row.flag">{{ scope.row.projectRemarks }}</span>
                  <span v-else>
                  <el-input size="mini" placeholder="输入用途" v-model="listData[scope.$index].projectRemarks" @input="getNum(scope.row.num,scope.row.number,scope.row.registrar,scope.row.remarks,scope.row.projectRemarks,scope.$index)" ></el-input>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="登记时间" width="160" prop="salaryMonth" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate}}</span>        
                </template>
              </el-table-column>
            </el-table>
              <!-- 提交弹出框 -->
            <el-dialog
              :title="dialogTitle1"
              :visible.sync="imoportVisible"
              center
              :append-to-body="true"
              :before-close="handleClose1"
              :lock-scroll="false"
              width="30%"
            >
              <template>
                <el-table :data="tableData1" style="width: 100%" border>
                  <el-table-column label="状态" >
                    <template slot-scope="scope">
                      <span v-if="scope.row.code==200">
                        <i class="el-icon-circle-check" style="color:#07C160"></i>
                      </span>
                      <span v-else>
                        <i class="el-icon-warning-outline" style="color:#f00"></i>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                      <span v-if="scope.row.code==200" style="color:#07C160">{{scope.row.msg}}</span>
                      <span v-else style="color:#f00">{{scope.row.msg}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    var checkPrice = (rule, value, callback) => {
        // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
            if (value == '') {
                callback(new Error('请输入单价'))
            } else if (!this.isCellPrice(value)) {
                //引入methods中封装的检查手机格式的方法
                callback(new Error('请输入正确的格式!'))
            } else {
                callback()
            }
        }
    return {
      listData: [],
      search: {
        //查询
        name: '',
        groupId: '',
        date:util.myTime.getCurTime(),
        type:'',
        userType:util.session.get('roleId'),
        itemsType:'',
        projectRemarks:'',//项目用途
      },
      classId: '', //班组id
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      uploadUrl:base.url+'/inoutApply/uploadInoutApply',
      uploadHead: {
        accessToken: this.$store.state.token
      },
      // uploadData:{
      //    personId:'',
      //    type:'2',
      //    itemsType:'1',
      //    userType:'1',
      //    groupId:'',
      //    flag:true
      // },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dialogTitle1: '导入结果',
      imoportVisible: false,
      tableData1: [],
      editFormVisible: false,
      diaTitle:"",
      jsonArry:[],
      multipleSelection: [],
      checked:false,
      jsonString:''
      
    }
  },
  created() {
    //  if(util.session.get('roleId')=='4'){
      this.search.groupId = util.session.get('groupId')
    // }else{
    //   this.search.groupId = util.session.get('proId')
    // }
  },
  mounted() {
     this.search.itemsType = this.$route.params.itemsType
     this.search.type = this.$route.params.type
      // this.uploadData.personId = this.$store.state.user.id
      // this.uploadData.groupId = this.search.groupId
      this.getData()
            
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.search.personStatus = index
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      myHttp
        .selectInventoryNumberList(this.search)
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              that.listData=resp.data.data.InventoryNumber||[]
              for(var i=0;i<that.listData.length;i++){
               that.listData[i].flag =false
               that.listData[i].num = '0'  
               that.listData[i].registrar=''  
               that.listData[i].remarks='' 
               that.listData[i].projectRemarks=''
              }
              if(resp.data.data.InventoryNumber,length==0){
                 that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {
            that.dataText = '服务器繁忙中，请稍后请求'
          }
        )
    },
 

    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
   
   
   
     /**
  * 导出合同
      */
    exportma(flag) {
      var token = util.session.get('token')
      window.open(
         myHttp.exportInoutApply+
          '?type='+
           this.search.type+
          '&itemsType=' +
           this.search.itemsType +
          '&groupId=' +
           this.search.groupId +
           '&userType='+
           this.search.userType+
           '&date='+
           this.search.date+
           '&name='+
           this.search.name+
           '&flag='+
            flag+
           '&accessToken=' +
            token
         )
        },
        handleClose1(){
          this.imoportVisible=false
          if(this.search.userType=='4'){
           this.$router.push({path:'/Warehousing'})
          }else{
            this.$router.push({path:'/outCon'})
          }
       
        },
     /**
     * 导入表监听方法
     */
    // handleAppSuccess(res, file) {
    //   console.log(res)
    //   // if (res.code == '200') {
    //     // this.$message.success('上传成功')
    //     console.log(res)
    //     this.imoportVisible = true
    //     this.tableData1 = res.list
    //     this.getData()
    //   // } else {
    //   //   this.$message.error(res.msg)
    //   // }
    // },
    // 多选
    handleSelectionChange(val) {
      for(var i=0;i<this.listData.length;i++){
        this.listData[i].flag =false
      }
        // console.log(val)
        this.multipleSelection = val;
        var jsonArry =[]
        for(var i = 0;i<val.length;i++){
          val[i].flag =true
          var obj = val[i]
          // console.log(obj)
          jsonArry.push({
            "materialCoding":obj.materialCoding,
            "num":obj.num,
            "registrar":obj.registrar
          })
        }
        var jsonString = JSON.stringify(jsonArry)
        this.jsonString = jsonString
        console.log(jsonString)
        if(this.multipleSelection.length!=0){
            // val[i].flag =false
            this.checked = true
        }
        
    },
   // 提交出库
   add(){
   console.log(this.multipleSelection)
       for(var i=0;i<this.multipleSelection.length;i++){
         if(this.multipleSelection[i].num==0||this.multipleSelection[i].registrar==''||this.multipleSelection[i].remarks==''){
           this.$message.warning("请填写出库数量和领料人以及用途")
           return;
         }
        //  if()
       }
        var that =this
        this.$confirm('此操作将提交该调数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
          myHttp.outInoutApply({
            personId:this.$store.state.user.id,
            type:this.search.type,
            itemsType:this.search.itemsType,
            groupId:this.search.groupId,
            userType:this.search.userType,       
            jsonString:this.jsonString,
            // registrar:this.$store.state.user.name
           }).then(function(resp){
            
            if(resp.data.code==200){
               var list =resp.data.data
                 that.imoportVisible = true
                 that.tableData1 =list.Entity
                that.getData();
            }else{
                that.$message.error(resp.data.msg);
            }
          });
        })
        .catch((err) => {})
   },
  //  
  getNum(num,number,reg,remarks,projectRemarks,index){
      // console.log(num,number,index)
      if(num<'0'){
        num==0
        this.$message.warning('出库不能小于0')
        return;
      }

      this.$forceUpdate()
      var obj = this.listData[index]
      // console.log(obj)
      // obj.num = num
      this.listData[index] = obj
      // console.log(this.listData)
      var jsonArry =[]
      for(var i =0;i<this.listData.length;i++){
        if(this.listData[i].flag){
          var obj = this.listData[i]
          jsonArry.push({
          "materialCoding":obj.materialCoding,
          "num":obj.num,
          "registrar":obj.registrar,
          "remarks":obj.remarks,
          "projectRemarks":obj.projectRemarks
        })
        }
      }
      var jsonString = JSON.stringify(jsonArry)
        this.jsonString = jsonString.toString()
        console.log(jsonString)
        // console.log( typeof(jsonString) )
      //列表添加属性--》让vue监听到列表的变动
      this.$set(this.listData,'num'+num,num)
      //删除列表中刚添加的属性
      delete this.listData['num'+num]
  }

  }
}
</script>
<style>
/**
*图片放大右上角关闭按钮
*/
.el-image-viewer__close i{
    font-size: 4vh;
    color: #fff;
}
/* @import '../../assets/css/common.css'; */
</style>
<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 80px);
}
.active {
  background: #409eff;
  color: #fff;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
  padding: 10px 0px;
}
.content >>>.el-input-group--append .el-input__inner{
  width: 200px;
}
.content >>>.el-tree{
 padding:30px;
}
</style>